<template>
    <div class="content">
        <div class="card card-default">
            <div class="card-header">
                <h3 class="card-title"> </h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-toggle="dropdown" title="Công cụ">
                        <i class="fas fa-cogs"></i>
                        <div class="input-group-prepend">
                            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                <export-excel class="dropdown-item text-green" :data="exportDatas" worksheet="report" type="xls" name="report.xls">
                                    <i class="fas fa-file-excel"></i>&nbsp;&nbsp;Xuất file Excel
                                </export-excel>
                                <div class="dropdown-divider"></div>
                            </div>
                        </div>
                    </button>
                    <button type="button" class="btn btn-tool" @click="getData" title="Tải lại">
                        <i class="fas fa-arrows-rotate"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Thu gọn">
                        <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Ẩn">
                        <i class="fas fa-times"></i>
                    </button>

                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-md-3 mb-3">
                        <TheSelect id="" title="" :options="pageOptions" :initialValue="perPage.toString()" @onChange="(v) => onChangePageOptions(v)" />
                    </div>
                    <div class="col-md-3">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Nhập  từ khóa tìm kiếm" v-model="filter">
                            <div class="input-group-append">
                                <span class="input-group-text" @click="onSearchKey" role="button">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive p-0">
                    <!-- loading overlay -->
                    <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                    <!-- table data -->
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="col5">#</th>
                                <th class="col80">Tên menu</th>
                                <th class="col200">Đường dẫn</th>
                                <th class="col200 text-center">Icon</th>
                                <th class="col200 text-center">Sắp xếp</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items" :key="item.id">
                                <td style="vertical-align: middle !important;">{{ index + 1 }}</td>
                                <td style="vertical-align: middle;">{{ item.menuName }}</td>
                                <td style="vertical-align: middle;">{{ item.path }}</td>
                                <td style="vertical-align: middle;" class="text-center"><span v-html="item.icon"></span></td>
                                <td style="vertical-align: middle;" class="text-center">{{ item.orderNumber }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <p> Selected Rows:<br>{{ selected }} </p> -->
                <!-- row info and paging -->
                <div class="row">
                    <div class="col-md-6">
                        <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng</div>
                        <div v-else>Không có dữ liệu</div>
                    </div>
                    <div class="col-md-6">
                        <div class="float-right">
                            <ul class="pagination pagination-rounded">
                                <paginate :page-count="pageCount" :page-range="3" :margin-pages="2"
                                    :click-handler="handlePageChange" :prev-text="'Trở lại'" :next-text="'Kế đến'"
                                    :container-class="'pagination'" :page-class="'page-item'">
                                </paginate>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import TheSelect from '@/components/shared/UserInput/TheSelect.vue';

export default {
    components: {
        paginate: Paginate,
        loading: Loading,
        TheSelect
    },
    name: "TheMenu",
    data() {
        return {
            isBusy: false,
            streamFileUrl: `${process.env.VUE_APP_API_URL}/Common/StreamFile?url=`,
            // table
            filter: null,
            items: [],
            exportDatas: [],
            currentPage: config.CURRENT_PAGE,
            perPage: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: "createdDate",
            sortDesc: true,
            filterOn: [],
            numberOfShow: 0,

            selectedDataset: null,

            numberOfScheduleStep: 0,

            hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
            minuteOptions: ['00', '30'],
            refreshScheduleEnabled: false,

            selectedDatasetId: '',

            title: "",
            code: "",
            styleButton: "",
            // For mesage validate
            errors: {},
            isLoading: false,
            selected: [],
            rowSelected: null,
            isUpdate: false
        }
    },
    methods: {
        // Map action
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('menu', ['getAllPagingMenu']),
        ...mapActions('alert', ['warning',]),
        // setup
        async setup() {
            //setup dynamic header
            let header = 'Quản lý menu';
            this.setupHeader({ header });      
        },

        // ------ get data datatable ------
        async getData() {
            // state for loading overlay
            this.isBusy = true;

            // Call get data
            let params = {
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                searchKey: this.filter
            };
            let rs = await this.getAllPagingMenu(params);
            if(rs.isOk) {
                // List data
                this.items = rs.data.data;
                // Total row
                this.totalRow = this.items.length;
                // Number show
                this.numberOfShow = ((this.currentPage - 1) * this.perPage) + this.items.length;
                // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.perPage)) + 1;
                // For export excel
                this.exportDatas = this.items.map(({ rowNumber, id, menuName }) => ({
                    rowNumber, id, menuName
                }));
            }

            this.isBusy = false;
        },        
        // sortingChanged
        async sortingChanged() {
            //console.log(this.perPage)
            await this.getData();
        },
        // function for paging
        async handlePageChange(page) {
            this.currentPage = page;
            //console.log(this.currentPage)
            await this.getData();
        },
        // function for select number in page
        async onChangePageOptions(perPage) {
            this.perPage = perPage;
            await this.getData();
        },
        // function for search key 
        async onSearchKey() {
            //console.log(this.filter)
            //this.filter = e.target.value
            await this.getData();
        },

    },
    async mounted() {
        // setup title header
        await this.setup();
        // get data table
        await this.getData();
        //Initialize Select2 Elements
        // $(".select2").select2();
        // //Initialize Select2 Elements
        // $(".select2bs4").select2({
        //     theme: "bootstrap4",
        // });
        $('#pageOptions').on('change', e => {
            this.onChangePageOptions(e.target.value);
        });
    },
    async created() {

    }
}
</script>

<style>

</style>
